export const ALLOWED_DOCUMENT_TYPES = ['parental-consent-form', 'third-party-consent-form'];